exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_wks-ext.js
// module id = 283
// module chunks = 48 49 50 51